export const getters = {
  productBoostList: ({ productBoostList }) => productBoostList,
};
